import { Translation } from "../model/Translation";
import axiosInstance from "../utils/ApiUtils/axiosInstance";

export const fetchAvailableTranslations = async () => {
  const response = await axiosInstance.get<ApiResponse<Translation[]>>("/api/translation/phase/list-data-to-translate");
  return response.data.data;
};
